import React, { Component } from 'react'
import { connect } from 'react-redux'

import { actualizarDatosParaMuiTable } from '../actions/TablaDistribucionPorCerealActions'
import { TablaDistribucionPorCerealView } from '../components/TablaDistribucionPorCerealView'

class TablaDistribucionPorCereal extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable(this.props.conLink)
  }

  render () {
    return <TablaDistribucionPorCerealView />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaDistribucionPorCereal)
